import React from 'react';
import { useMap } from 'react-leaflet';
import { Position } from '../../types';
import { MAP_CONFIG, MOBILE_PADDING, DESKTOP_PADDING } from '../../config/mapConfig';

interface RecenterButtonProps {
  position: Position | null;
  onRecenter: () => void;
}

const RecenterButton: React.FC<RecenterButtonProps> = ({ position, onRecenter }) => {
  const map = useMap();

  const handleRecenter = () => {
    onRecenter(); // Force a new position detection
    
    if (position) {
      const isMobile = window.innerWidth <= MAP_CONFIG.mobileBreakpoint;
      const zoomLevel = isMobile ? MAP_CONFIG.mobileZoom : MAP_CONFIG.desktopZoom;
      
      // Add padding to compensate for legend and controls
      const paddingOptions = isMobile ? MOBILE_PADDING : DESKTOP_PADDING;
      
      setTimeout(() => {
        map.flyTo(position, zoomLevel, {
          duration: MAP_CONFIG.recenterDuration,
          ...paddingOptions,
        });
      }, MAP_CONFIG.recenterDelay);
    }
  };

  if (!position) return null;

  return (
    <button 
      className="recenter-button" 
      onClick={handleRecenter} 
      title="Recentrer sur ma position"
    >
      <span className="recenter-icon">⌖</span>
    </button>
  );
};

export default RecenterButton;
